import { Button, Flex, Typography } from "antd";
import { Content } from "antd/es/layout/layout";
import AuthTitleAndDescription from "../../../components/auth/AuthTitleAndDescription";
import ForgotPasswordForm from "../../../components/auth/ForgotPasswordForm";
import BackgroundSVGs from "../../../components/auth/layout/BackgroundSVGs";
import { Link, useNavigate } from "react-router-dom";
import LookFindrLogo from "../../../assets/images/LookfindrLogo";
import { useIntl } from "react-intl";
import { primaryLanguagesChanger } from "../../../assets/SVGs/SVGs";
import { useDispatch, useSelector } from "react-redux";
import { setCurrentLang } from "../../../services/store/slices/user";
import queryClient from "../../../services/react-query/queryClient";

function ForgotPassword() {
  const dispatch = useDispatch();
  const currentLang = useSelector((state: any) => state?.user?.currentLang);
  const navigate = useNavigate();
  const intl = useIntl();
  const handelChangeLng = () => {
    dispatch(setCurrentLang(currentLang === "ar" ? "en" : "ar"));
    document
      .getElementsByTagName("html")[0]
      .setAttribute("lang", currentLang === "ar" ? "en" : "ar");
    localStorage.setItem("currentLang", currentLang === "ar" ? "en" : "ar");
    setTimeout(() => {
      // queryClient.clear();
      queryClient.invalidateQueries();
      // window.location.reload();
    }, 500);
  };
  return (
    <Content className="bg-white">
      <BackgroundSVGs />
      <Flex
        justify="center"
        align="center"
        style={{
          minHeight: "100vh",
        }}
        className="pt-[20px]"
      >
        <div
          className="w-[338px]  md:w-[680px]  my-2   shadow-full relative bg-white
              px-[16px] md:px-[60px] py-[32px] sm:py-[40px]  rounded-[12px] "
        >
          <div>
            <Button
              className="header-lang-btn !text-color-primary hover:!text-color-primary"
              onClick={handelChangeLng}
              icon={primaryLanguagesChanger()}
            >
              {currentLang === "ar" ? "English" : "العربية"}
            </Button>
          </div>
          <Flex vertical gap={"20px"} className="relative">
            <Flex justify="center" align="center">
              <LookFindrLogo
                onClick={() => {
                  navigate("/register");
                }}
              />
            </Flex>
            <AuthTitleAndDescription
              titleAndDescription={{
                title: intl.formatMessage({ id: "resetPassword" }),
                description: intl.formatMessage({ id: "toCreateNewPassword" }),
              }}
            />
            <ForgotPasswordForm />
          </Flex>
          <Flex justify="center" className="">
            <Link className="text-txt-link font-semibold" to="/login">
              {intl.formatMessage({ id: "backToLogin" })}
            </Link>
          </Flex>
        </div>
      </Flex>
    </Content>
  );
}

export default ForgotPassword;
